export default "__VITE_ASSET__Cb3NqG$g__"